import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class StatisticsService {
    getTotalUpload() {
        return axios.get(API_URL + 'statistics/total-uploads', { headers: authHeader() });
    }
    getTotalUser() {
        return axios.get(API_URL + 'statistics/total-user', { headers: authHeader() });
    }
    getHistoryReports() {
        return axios.get(API_URL + 'statistics/history-report', { headers: authHeader() });
    }
    getMalwareAnalyzed(params) {
        return axios.get(API_URL + 'statistics/analyzed-malware', { params: params, headers: authHeader() });
    }
    getMalwareDetection(params) {
        return axios.get(API_URL + 'statistics/malware-detection', { params: params, headers: authHeader() });
    }

    getMalwareRecap(params) {
        return axios.get(API_URL + 'statistics/malware-recap', { params: params, headers: authHeader() });
    }
    getTotalReport() {
        return axios.get(API_URL + 'statistics/total-report', { headers: authHeader() });
    }
    getTotalReportByStatus(data) {
        return axios.get(API_URL + 'statistics/report-by-status', data, { headers: authHeader() });
    }
    getTopReport(data) {
        return axios.post(API_URL + 'statistics/top-analyst', data, { headers: authHeader() });
    }
    getDailyReport(params) {
        return axios.get(API_URL + 'statistics/daily-report', { params: params, headers: authHeader() });
    }
    getAhnSandbox(ip, data) {
        return axios.post(ip + 'ahn_sandbox/_search?scroll=10m', data, { headers: { 'Content-Type': 'application/json' } });
    }
    getCheckpointSandbox(ip, data) {
        return axios.post(ip + 'checkpoint_sandbox/_search?scroll=10m', data, { headers: { 'Content-Type': 'application/json' } });
    }
}

export default new StatisticsService();
